import GSAP from 'gsap'

const main = document.querySelector('main')
const loader = document.querySelector('.loader')
const title = document.querySelector('.loader h2')
const text = document.querySelector('.loader p span')
const btn = document.querySelector('.start')
const counterWrapper = document.querySelector('.counter_wrapper')
const counter = document.querySelector('.counter')
const music = document.querySelector('.music')

const btnAudio = document.querySelector('.btnAudio')
music.muted = true
music.volume = 0.05

//counter increase
function updateCount() {
  const count = +counter.innerText

  let target = 100
  let speed = 500
  const inc = target / speed

  if (count < target) {
    counter.innerText = Math.ceil(count + inc)
    setTimeout(updateCount, 1)
  } else {
    counter.innerText = target
  }
}

//Introloader
function onContentLoaded() {
  main.style.visibility = 'hidden'
  setTimeout(() => {
    const tl = GSAP.timeline()
    tl.fromTo(title, { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)', duration: 1, ease: 'ease' })
      .fromTo(btn, { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, duration: 1 }, '<= 2')
      .fromTo(text, { autoAlpha: 0, y: 10 }, { autoAlpha: 0.5, y: 0 })
  }, 1000)
  updateCount()
}

//Magnetic Button
function moveBtn(e) {
  const target = e.currentTarget
  const bounding = target.getBoundingClientRect()
  GSAP.to(target, 1, {
    x: ((e.clientX - bounding.left) / bounding.width) * 20,
    y: ((e.clientY - bounding.top) / bounding.height) * 20,
    ease: 'Power4.easeOut',
  })
}

//Close Intro
function closeLoader() {
  const tl2 = GSAP.timeline()
  tl2
    .to(title, { autoAlpha: 0, y: 20, clipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0 100%)', ease: 'ease' })
    .to(btn, { autoAlpha: 0, y: 20 })
    .to(text, { autoAlpha: 0, y: 10 })
    .to(counterWrapper, { scale: 0.5, autoAlpha: 0, duration: 1 }, '<=0.4')
    .to(loader, { scale: 1.2, autoAlpha: 0, duration: 1.2, ease: 'linear', visibility: 'hidden' })
  main.style.visibility = 'visible'

  //Soundtrack and sound wave
  music.muted = false
  music.play()
  btnAudio.play()
  btnAudio.loop = true
}

//Events
btn.addEventListener('mousemove', moveBtn)
btn.addEventListener('click', closeLoader)
window.addEventListener('DOMContentLoaded', onContentLoaded)
